export default "/packs/d214faa108abae067e717502af2558f8.svg";